import React, { useState } from 'react';
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router';
import { useSelector } from 'react-redux';
import { appTheme, retrieveData } from 'helpers/utils/Utils';
import { GetApiHeadersWithBearer, GetRequest } from 'network/NetworkUtils';
import { STATUS_SUCCESS_CODE, ELIGIBILITY_CHECK_SECURED_CREDIT_CARD } from 'network/URLConstants';
import CustomAlertModel from '../../../CustomComponents/CustomAlertModel';
import Loader from '../../../CustomComponents/Loader';
const SuccessDeposit = ({ onClose }) => {
    const { t } = useTranslation();
    const cards = useSelector(state => JSON.parse(state.userCards));
    const accessTokenToApi = useSelector(state => state.accessToken);
    const [loading, setLoading] = useState(false);
    const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);
    const appThemeData = appTheme(kudzuPlusTrue)
    const navigate = useNavigate();
    const HighlightMsgStyles = "font-serif-pro modal-title text-[var(--modal-text-highlight)] lg:text-[32px] md:text-[28px] sm:text-[25px] text-[28px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[30px] font-normal cursor-pointer pointer-events-none";
    const HeaderMsgStyles = "font-serif-pro modal-title text-[var(--modal-text-heading-clr)] lg:text-[32px] md:text-[28px] sm:text-[25px] text-[28px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[30px] font-normal cursor-pointer pointer-events-none";
    const SubHeaderMsgStyles = "font-hanken-grotesk modal-title text-[var(--modal-text-heading-clr)] text-md font-normal cursor-pointer pointer-events-none";
    const [showModel, setShowModel] = useState(false);
    const [highlightMsg, setHighlightMsg] = useState('')
    const [headerMsg, setheaderMsg] = useState('')
    const [subHeaderMsg, setSubHeaderMsg] = useState('')
    const [btn1Exists, setBtn1Exists] = useState(false)
    const [btn2Exists, setBtn2Exists] = useState(false)
    const [btn1Text, setBtn1Text] = useState(false)
    const [btn2Text, setBtn2Text] = useState('')
    const [modelImage, setModelImage] = useState('')
    const [btn1TypeAcpt, setBtn1TypeAcpt] = useState(false)
    const [footerMsg, setFooterMsg] = useState('');
    const [btn1Focus, setBtn1Focus] = useState(false);
    const [btn2Focus, setBtn2Focus] = useState(false);
    const [subFooter, setSubFooter] = useState('');
    const [isBorderNone, setisBorderNone] = useState(true);
    const [showErrorImg, setshowErrorImg] = useState(false);
    const showAlertModal = (showModel, highlightMsg, headerMsg, subHeaderMsg, btn1Exists, btn2Exists, btn1Text, btn2Text, btn1TypeAcpt, modelImage, footerMsg, showErrorImg, isBorderNone, btn1Focus, btn2Focus) => {
        setshowErrorImg(showErrorImg)
        setisBorderNone(isBorderNone)
        setShowModel(showModel)
        setHighlightMsg(highlightMsg)
        setheaderMsg(headerMsg)
        setSubHeaderMsg(subHeaderMsg)
        setBtn1Exists(btn1Exists)
        setBtn2Exists(btn2Exists)
        setBtn1Text(btn1Text)
        setBtn2Text(btn2Text)
        setBtn1TypeAcpt(btn1TypeAcpt)
        setModelImage(modelImage)
        setFooterMsg(footerMsg)
        setBtn1Focus(btn1Focus)
        setBtn2Focus(btn2Focus)
    }
    const handleBackToService = () => { eligibilityCheckSecuredCreditCard(); }
    const eligibilityCheckSecuredCreditCard = async () => {
        const deviceId = await retrieveData('updatedDeviceId');
        const headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);
        setLoading(true);
        const url = ELIGIBILITY_CHECK_SECURED_CREDIT_CARD.replace('{CARD_KEY}', cards !== null ? cards[0].CardKey : 0);
        try {
            const response = await GetRequest(url, headers);
            setLoading(false);
            const parsedResponse = JSON.parse(response);
            if (parsedResponse.ResponseCode == STATUS_SUCCESS_CODE) {
                if (parsedResponse.Response.canCreateNew) {
                    navigate('/secured-credit/terms-and-conditions');
                } else {
                    onClose();
                    navigate("/secureCredit/DepositFunds");
                }
            } else {
                const arrMessages = parsedResponse.Messages;
                const message = arrMessages[0];
                const displayText = message.DisplayText;
                showAlertModal(true, t("oops_exclamation"), '', displayText, true, false, t('home'), t('back_to_card_services'), true, require('../../../../assets/images/warning.png'), '', false, false, true, false)
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }

    }
    const closeModel = () => {
        setShowModel(false);
    }

    const onAcptBtnClick = () => {
        navigate('/home')
    }
    const onCancelBtnClick = () => {
        setShowModel(false)
    }

    return (

        <div className="w-full">
            <div className="mx-auto w-full max-w-[520px] px-6 sm:px-10 pb-10">

                <div className="mt-6 flex justify-center">
                    <img
                        src={appThemeData.DepositComplete}
                        alt="complete"
                        className="
                        w-[72px] h-[72px]
                        sm:w-[90px] sm:h-[90px]
                        md:w-[96px] md:h-[96px]"/>
                </div>

                <div className="mt-10 flex flex-col items-center gap-6">

                    <button
                        autoFocus
                        onClick={handleBackToService}
                        className="
                        focus:outline-none
                        bg-[#2965FB] text-white
                        border-2 border-[#2965FB]
                        rounded-none
                        h-[48px]
                        w-full sm:w-[360px] md:w-[420px]
                        font-hanken-grotesk font-semibold
                        text-[14px] sm:text-[16px]
                        leading-none
                        flex items-center justify-center
                        active:scale-[0.99] transition">
                        {t("DEPOSIT_FUNDS_SUCCESS_BTN_TEXT")}
                    </button>

                    <button
                        onClick={() => navigate("/home")}
                        className="
                            font-hanken-grotesk font-medium
                            text-[12px] sm:text-[14px]
                            text-[#2965FB]">
                        {t("home")}
                    </button>
                </div>
            </div>


            {showModel &&
                <CustomAlertModel
                    isOpen={showModel}
                    onClose={closeModel}
                    image={modelImage}
                    highlightMsg={<p className={`${HighlightMsgStyles} sm:flex block flex-col`}>{highlightMsg}
                        <span className={HeaderMsgStyles}> {headerMsg}</span></p>}
                    subHeaderMsg={<p className={SubHeaderMsgStyles}>{subHeaderMsg}</p>}
                    btn1Exists={btn1Exists}
                    btn2Exists={btn2Exists}
                    btn1Text={btn1Text} btn2Text={btn2Text}
                    btn1TypeAcpt={btn1TypeAcpt}
                    verificationFailure={() => { }}
                    footerMsg={<p className={SubHeaderMsgStyles}>{footerMsg}</p>}
                    onAcptBtnClick={onAcptBtnClick}
                    subFooter={<p className={SubHeaderMsgStyles}>{subFooter}</p>}
                    onCancelBtnClick={onCancelBtnClick}
                    showErrorImg={showErrorImg}
                    isBorderNone={isBorderNone}
                    btn1Focus={btn1Focus}
                    btn2Focus={btn2Focus}
                />
            }
            {loading && <Loader />}
        </div>

    )
}

export default SuccessDeposit